module.exports = {
	"articleTitle1": "Tim Hortons, men's shop among new Ann Arbor businesses",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Elixir Vitae Coffee and Tea",
	"articleLink1": "https://www.michigandaily.com/news/new-businesses-open-around-ann-arbor",
	"articleLink2": "https://www.michigandaily.com/arts/11kathleen-davis-coffee-culture-column04",
	"articleSnippet1": "Sep 13, 2012 ... Ann Arbor citizens know good coffee, according to Jimmy Curtiss, a manager at \nElixir Vitae Coffee and Tea on Maynard Street, the coffee shop ...",
	"articleSnippet2": "Nov 3, 2014 ... Smaller shops like Elixir Vitae Coffee and Tea have fair trade options if you ask. \nThe options are there if you know where to work, and the whole ...",
	"foodRecommendations": [
		{
			"text": "I don’t know if this is just in my head, but does this place always feels slightly damp? Just like a mildly moist atmosphere? Even so, it’s one of the best coffee places to actually get work done. The bathroom is pretty clean, with some fun graffiti and good selfie lighting. It’s also a prime location for talking shit — if you’re trying to gossip, settle in with a cup of tea and one of the oatmeal bars they sell at the reister. But chatter with caution. It’s right down the street from The Michigan Daily and the Union, you’ll probably see someone you know either walking by or sitting on one of the threadbare chairs.",
			"person": "Rebecca Lerner"
		}
	],
	"articleTitle2": "Report an Issue - ",
	"address": "328 Maynard St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.2784,
		"lng": -83.7424
	},
	"totalMisc": 0,
	"categories": {
		"coffeeshop": 1,
		"fooddrink": 1,
		"location": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/elixirVitae.json
// module id = 873
// module chunks = 0